export default function buildResponse(data, options) {
    const response = new Response(data);
    for(const optionUntyped in options){
        if (options.hasOwnProperty(optionUntyped)) {
            const option = optionUntyped;
            Object.defineProperty(response, option, {
                configurable: true,
                enumerable: true,
                get: ()=>options[option]
            });
        }
    }
    return response;
}

//# sourceMappingURL=buildResponse.js.map